import { Add } from '@mui/icons-material';
import { Box, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { TableType } from '../../apiTypes';
import PrimaryButton from '../../components/PrimaryButton';
import { t } from '../../constants/translations';
import { useLocale } from '../../contexts/locale.context';
import { tableParams } from './EditTableMap';

const tables: TableType[] = ['square', 'circle', 'rectangleH', 'rectangleV', 'barH', 'barV'];

type Props = {
  onAddTable: (type: TableType, x: number, y: number) => void;
};

const AddTableButton = ({ onAddTable }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { lang } = useLocale();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddTable = (type: TableType, x: number, y: number) => {
    onAddTable(type, x, y);
    handleClose();
  };

  return (
    <div>
      <PrimaryButton onClick={handleClick} startIcon={<Add />}>
        {t.add_table[lang]}
      </PrimaryButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {tables.map((type) => (
          <MenuItem key={type} onClick={() => handleAddTable(type, 0.5, 0.5)}>
            <Box width={20} mr={1}>
              <Box
                sx={{
                  width: `${tableParams[type].h / 4}px`,
                  height: `${tableParams[type].w / 4}px`,
                  borderRadius: type === 'circle' ? '50%' : '0px',
                  backgroundColor: (t) => t.palette.secondary.main,
                  m: '0 auto',
                }}
              />
            </Box>
            {t[type][lang]}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default AddTableButton;
